import { type QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { APIClientProvider } from "common/components/APIClientProvider"
import { router } from "common/routing/router"
import { SnackbarProvider } from "notistack"
import { type PropsWithChildren } from "react"
import { type AsyncClient } from "../api"
import { AsyncClientProvider } from "./AsyncClientProvider"
import { ConnectedUserProvider } from "./ConnectedUserProvider"
import { MuiTheme } from "./MuiTheme"
import { NavProvider } from "./NavProvider"
import { RouterProvider } from "./RouterProvider"
import { APIProvider as GoogleMapsAPIProvider } from "@vis.gl/react-google-maps"
import { Client } from "common/api/client"
import { ConnectedUser } from "../domains/user/model"

export function AppProviders({
  queryClient,
  apiClient,
  asyncClient,
  connectedUser,
  nav,
  googleMapsApiKey,
  children,
}: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <APIClientProvider client={apiClient}>
        <MuiTheme>
          <SnackbarProvider>
            <RouterProvider router={router}>
              <AsyncClientProvider client={asyncClient}>
                <NavProvider nav={nav}>
                  <ConnectedUserProvider user={connectedUser}>
                    <GoogleMapsAPIProvider apiKey={googleMapsApiKey}>
                      {children}
                    </GoogleMapsAPIProvider>
                  </ConnectedUserProvider>
                </NavProvider>
              </AsyncClientProvider>
            </RouterProvider>
          </SnackbarProvider>
        </MuiTheme>
      </APIClientProvider>
    </QueryClientProvider>
  )
}

type Props = PropsWithChildren<{
  queryClient: QueryClient
  apiClient: Client
  asyncClient: AsyncClient
  connectedUser: ConnectedUser | null
  nav: NavItem | null
  googleMapsApiKey: string
}>
